import React, { Component } from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import ServiceDataTable from './ServiceDataTable'

export default class NewServiceTableWrapper extends Component {
    render() {
        return (
            <div>
                <Header />
                 <Menu/>
                <>
              <div className="content-wrapper">
              <ServiceDataTable/>

              </div>
              </>
              <Footer/>

            </div>
        )
    }
}
